module.exports = __webpack_public_path__ + "06d9665b7d41b98bbe08347dbacc0da3.MP3";